import type { FontFamily } from '@/api/types/font-family'
import type { ParagraphBlockFontLookup } from '@/lib/text/types/paragraph-block-font-lookup'

/** Minimal `ParagraphBlockFontLookup` built from the same `FontFamily[]` list `pages/home` already
 *  keeps live in `fontFamiliesRef` — lets the shape-text measurer resolve real CSS family/weight/
 *  style for accurate width measurement, without needing the `FontProvider` React context. */
export function buildFontLookupFromFamilies(fontFamilies: FontFamily[]): ParagraphBlockFontLookup {
  const cssNameByFamilyId = new Map<number, string>()
  const variantByFontId = new Map<number, { bold: boolean; italic: boolean }>()

  for (const family of fontFamilies) {
    cssNameByFamilyId.set(family.fontFamilyId, family.familyName)
    for (const font of family.fonts ?? []) {
      variantByFontId.set(font.fontId, { bold: font.bold, italic: font.italic })
    }
  }

  return {
    getFamilyCssName: (id) => cssNameByFamilyId.get(id),
    getVariantByFontId: (id) => variantByFontId.get(id),
  }
}
